// extracted by mini-css-extract-plugin
export default {"advertWrapper":"_1ZdKS6gi","advert":"a1OXl78j","placeholder":"AdUnit_placeholder__a3eRDMZV","background":"AdUnit_background__-npZUXiM","content":"AdUnit_content__Wy07HoId"};